import { render } from "./LinkProfile02.vue?vue&type=template&id=d0f9f4d4&scoped=true"
import script from "./LinkProfile02.vue?vue&type=script&lang=js"
export * from "./LinkProfile02.vue?vue&type=script&lang=js"

import "./LinkProfile02.vue?vue&type=style&index=0&id=d0f9f4d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f9f4d4"]])

export default __exports__